import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

import React, { useState } from "react";
import { Alert, Button, Col, Form, Modal, Spinner } from "react-bootstrap";
import CardInput from "../../../Components/CardInput";
import 'bootstrap/dist/css/bootstrap.min.css';
import { STRIPR_WARNING_MSG } from "../../../utils";


const AddCard = ({ show, customer, handleClose, handleSuccess, stripeKey}) => {
    const stripe = useStripe();
    const elements = useElements();
    const [submitting, setSubmitting] = useState(false);
    const [stripeError, setStripeError] = useState(undefined);
    const [apiError, setApiError] = useState(undefined);

    const onSubmit = async (event) => {
        setSubmitting(true);
        setStripeError(undefined);
        setApiError(undefined);
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            setStripeError("Stripe hasn't loaded yet.");
            setSubmitting(false);
            return;
        }
 
        const { token:data, error }  = await stripe.createToken(elements.getElement(CardElement));
        if (error) {
            setStripeError(error.message);
            setSubmitting(false);
            return;
        }
        const sanitizedData = {
            userId: customer.profile.id,
            sourceToken : data.id
        };

        try {
            //console.log(sanitizedData);
            await handleSuccess(sanitizedData);
            setSubmitting(false);
        } catch (e) {
            setApiError(e?.message || "System error");
            setSubmitting(false);
            console.log(e)
        }
    }
    return (
        <Modal show={show} onHide={handleClose} size="lg">
              <Form onSubmit={onSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Add the details of the credit card you want to add</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(!stripeKey)&&(
                        <Alert variant="warning">{STRIPR_WARNING_MSG}</Alert>
                    )}
                    <Col style={{padding : "5px 20px", marginBottom : 15}}>
                        <CardInput/>
                        {stripeError && (<span className="error-text">
                            {stripeError}
                        </span>)}
                    </Col>
                    {apiError && (
                        <Alert variant="danger">{apiError}</Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" type="submit" disabled={submitting}>
                        {submitting && <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />}
                        Add Card
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default AddCard;